import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const Deonline = ({ navigation, route }: any) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        deductions3,
        deductions5,
        deductions7,
        deductions8,
        deductions10,
        totalAtoC,
        totalincome,
        adjustgrossincome,
        propotionaldecimal,
        estimatedTaxableincome,
        grossTaxliability,
        personalcredits,
        netLiability,
        estimatedTaxliability,
        gtotal,
        totaladjustments,
        withholdingpayperiod
    } = route.params

    const personalstore = usePersonalStore()
    const intializestore = useInitializeStore()

    const { postdeonline, loading } = useFormsStore()

    const handlesubmit = async (signatureDataURL: any) => {
        const data = {
            entityId: personalstore.personalData?.entityId,
            essUserKey: intializestore.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            // taxpayerid: values?.taxpayerid,
            totalNoOfDependents: values?.totalnoofdependents,
            additionalAmount: values?.additionalamount,
            residentOrNonresident: values?.residentornonresident,
            claimsYouAsADependent: values?.claimsyouasadependent ? values?.claimsyouasadependent : null,
            claimsYourSpouseAsADependent: values.claimsyourspouseasadependent ? values.claimsyourspouseasadependent : null,
            noOfDependentsExceptSpouse: values?.noofdependentsexceptspouse ? values?.noofdependentsexceptspouse : null,
            childDependentCareCredit: values?.childdependentcarecredit ? values?.childdependentcarecredit : null,
            over65OrBlind: values?.over65orblind ? values?.over65orblind : null,
            spouseOver65OrBlind: values.spouseover65orblind ? values.spouseover65orblind : null,
            gTotal: gtotal,
            receiveNonwageIncome: values?.receivenonwageincome ? values?.receivenonwageincome : null,
            itemizedDeductions: values?.itemizedDeductions ? values?.itemizedDeductions : null,
            deductions3: deductions3,
            alimonyPaid: values?.alimonypaid ? values?.alimonypaid : null,
            deductions5: deductions5,
            nonwageIncome: values?.nonwageincome ? values?.nonwageincome : null,
            deductions7: deductions7,
            deductions8: deductions8,
            deductions10: deductions10,
            claimForYourself: values?.claimforyourself ? values?.claimforyourself : null,
            claimForSpouse: values?.claimforspouse ? values?.claimforspouse : null,
            noOfDependents: values?.noofdependents ? values?.noofdependents : null,
            totalAToC: totalAtoC,
            wages: values?.Wages ? values?.Wages : null,
            nonwages: values?.nonwages ? values?.nonwages : null,
            totalIncome: totalincome,
            federalAdjustments: values?.federaladjustments ? values?.federaladjustments : null,
            delawareAdjustments: values?.delwareadjustmensts ? values?.delwareadjustmensts : null,
            totalAdjustments: totaladjustments,
            adjustedGrossIncome: adjustgrossincome,
            proportionalDecimal: propotionaldecimal,
            deductions: values?.deductions ? values?.deductions : null,
            estimatedTaxableIncome: estimatedTaxableincome,
            grossTaxLiability: grossTaxliability,
            personalCredits: personalcredits,
            netLiability: netLiability,
            estimatedTaxLiability: estimatedTaxliability,
            noOfPayPeriod: values?.noofpayperiod ? values?.noofpayperiod : null,
            withholdingPayPeriod: withholdingpayperiod,
            maritalStatus: values?.maritalStatus,
            sign: signatureDataURL
        }
        const response = await postdeonline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }




    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'DE Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('DeinformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                    })
                }
                onSubmit={handlesubmit}
                stateValue='DE'
            />
        </>
    )
}
export default Deonline

